export const config = {
  airTable: 'keyK3OwrWBVx56HTJ',
  base: 'appkuOJNJvlO1iFts',
  table: 'Emails list'
}
